<template>
    <div class="vc-checkout-accepted-cards">
        <div class="vc-checkout-accepted-cards__label">We accept</div>
        <div class="vc-checkout-accepted-cards__icons">
            <font-awesome-icon :icon="['fab','cc-visa']"></font-awesome-icon>
            <font-awesome-icon :icon="['fab','cc-mastercard']"></font-awesome-icon>
            <font-awesome-icon :icon="['fab','cc-amex']"></font-awesome-icon>
            <font-awesome-icon :icon="['fab','cc-jcb']"></font-awesome-icon>
            <font-awesome-icon :icon="['fab','cc-diners-club']"></font-awesome-icon>
            <font-awesome-icon :icon="['fab','cc-paypal']"></font-awesome-icon>
        </div>
    </div>
</template>

<script>
    export default {
        name: "checkout-accepted-cards"
    }
</script>

<style lang="scss" scoped>
    .vc-checkout-accepted-cards {
        text-align: center;
        user-select: none;

        &__label {
            font-size: 12px;
            text-align: center;
        }

        &__icons {
            font-size: 35px;
        }
    }
</style>